/*
 * HomePage
 *
 * This is the first thing users see of our App, at the '/' route
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import Container from 'components/Container';
import FeaturedGoods from 'components/FeaturedGoods/Loadable';
import PriceDisclaimer from 'components/PriceDisclaimer';
import HomeGeneral from './HomeGeneral';
import HomeDealer from './HomeDealer';
import HomeCG from './HomeCG';
import Seo from 'components/Seo';

// const LoggedIn = userIsAuthenticated(() => <div>Вход осуществлён</div>)
// const LoggedOut = userIsNotAuthenticated(() => <Login/>)

export class Home extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  


  render () {

    const { domain, seoTags } = this.props;
    let DisplayComponent = HomeGeneral;
    if (domain && domain.isCG === false) {
      DisplayComponent = HomeDealer;
    }
    if (domain && domain.isCG === true) {
      DisplayComponent = HomeCG;
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {seoTags.metaTitle}
          </title>
          <meta name="description" content={seoTags.metaDescription} />
        </Helmet>
        <DisplayComponent {...this.props} />

        <Container>
          <FeaturedGoods />
          <PriceDisclaimer forceAccessory/>
        </Container>

      </React.Fragment>
    );
  }
}

Home.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

// const mapStateToProps = createStructuredSelector({
//   seoTitle: makeSelectSeoTags('/', 'title'),
//   seoDescription: makeSelectSeoTags('/', 'description'),
// });

function mapDispatchToProps (dispatch) {
  return {
    dispatch,
  };
}

const withSeo = Seo() 


const withConnect = connect(null, mapDispatchToProps);

export default compose(
  withConnect,
  withSeo,
)(Home);
